export const LOGIN_SERVICE_FLAG =
  (process.env.REACT_APP_LOGIN_SERVICE ||
    (window as any)._env_.REACT_APP_LOGIN_SERVICE) === 'true';
